/* eslint-disable no-underscore-dangle */
import React from 'react';
import PropTypes from 'prop-types';
import { MultiSelect } from '@flightstats/component-lib';
import moment from 'moment';
import SearchSource from '../../sources/search';
import reportException from '../../../shared/lib/report-exception';

const propTypes = {
  value: PropTypes.array,
  placeholder: PropTypes.string,
  type: PropTypes.string,
};

const AsyncElasticsearchMultiSelect = (props) => {
  const formatItemByType = (type, item) => {
    switch (type) {
      case 'airport':
        return item ? `(${item._id}) ${item._source.name}` : '';
      case 'airline':
        return item ? `(${item._id}) ${item._source.shortName}` : '';
      default:
        return '';
    }
  };

  const buildOptions = (d) => {
    const { type } = props;

    return d.map(item => ({
      value: item,
      label: formatItemByType(type, item),
    }));
  };

  const formatQuery = input => ({
    gram: input,
  });

  const handleChange = (val = []) => {
    const { action, dispatch, identifier = '' } = props;
    const data = {
      identifier,
      val,
    };

    return dispatch(action(data));
  };

  const getOptions = (input, done) => {
    const serverTime = moment.utc().unix();
    const { type } = props;

    SearchSource[type](formatQuery(input), serverTime)
      .then(res => done(buildOptions(res.data)))
      .catch((ex) => {
        reportException(ex, 'AsyncElasticsearchMultiSelect');
        done([]);
      });
  };

  const { value, placeholder } = props;

  return (
    <div>
      <MultiSelect
        value={value && value.length ? value : []}
        placeholder={placeholder}
        handleMenuSelection={handleChange}
        handleRemoveSelection={handleChange}
        results={[]}
        handleChange={getOptions}
        clearable
        searchable
        async
        hideCaret
        bgColor='rgba(192, 192, 192, 0.66)'
        iconColor='white'
        placeholderColor='white'
        textColor='white'
      />
    </div>
  );
};

AsyncElasticsearchMultiSelect.propTypes = propTypes;

export default AsyncElasticsearchMultiSelect;
/* eslint-enable no-underscore-dangle */



// WEBPACK FOOTER //
// ./src/components/lib/AsyncElasticsearchMultiSelect.js